import {Component, Input, OnInit, OnChanges, Output, EventEmitter} from '@angular/core';
import { CompanyPickerModel } from '../model/company-picker.model';
import { ModalComponent } from '../../../../../common_libraries/controls/modal/modal.component';


@Component({
    selector: 'app-company-picker-modal',
    templateUrl: './company-picker-modal.component.html',
    styles: [],
    standalone: true,
    imports: [ModalComponent]
})
export class CompanyPickerModalComponent implements  OnInit, OnChanges {
  @Input() IsModal = true;
  @Input() DisplayList = false;

  @Output()
  DataLoaded: EventEmitter<any> = new EventEmitter();

  constructor( public model: CompanyPickerModel
  ) { }

  ngOnInit() {
   const prom = this.model.getCompanyList();
    if (prom != null) {
      prom.subscribe((res: any) => {
        this.DataLoaded.emit(res.json.data);
      });
    }
  }

  ngOnChanges(changes) {

  }
}
